var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-5"},[_vm._m(0),_c('br'),_c('p',[_vm._v("Страница, которую вы ищете, не найдена.")]),_c('br'),_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.comeBack}},[_vm._v("Вернуться назад")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('strong',[_vm._v("НЕ НАЙДЕНО")])])
}]

export { render, staticRenderFns }